import { AdditionalQuestions } from '../questions'

export default AdditionalQuestions
